import React, { Component } from 'react';
import { connect } from "react-redux";
import { startup, sync } from './redux/actions';
import { loggedInUser } from './redux/selectors'

import TopBackground from './components/assets/topBackground2.png';
import LoadingScreen from './components/screens/loadingScreen/loadingScreen';
import Header from './components/organisms/header/header';
import Shortcuts from './components/molecules/shortcuts/shortcuts';
import AirMeter from './components/organisms/airMeter';
import HappinessWidget from './components/organisms/happinessWidget/happinessWidget';
import WeatherWidget from './components/organisms/weatherWidget/weatherWidget';
import PuffWidget from './components/organisms/puffWidget/puffWidget';
import CompanyWidget from './components/organisms/companyWidget/companyWidget';
import HighFive from './components/molecules/highFive/highFive';
import Leaderboard from './components/organisms/leaderboard/leaderboard';
import Login from './components/screens/login';
import Profile from './components/screens/profile';
import HighFives from './components/screens/highFives';
import Video from './components/screens/video';
import EditShortcuts from './components/screens/editShortcuts';
import Employees from './components/screens/employees';
import HappinessFollowUp from './components/screens/happinessFollowUp';
import Settings from './components/screens/settings';

class Main extends Component {
  componentDidMount(){
    this.props.match && this.props.startup(this.props.match.params.customerId)
  }

  render() {
    const { loggedInUser, user, highFives, customerId, validatingCustomer, employeeHappiness } = this.props;
    if(validatingCustomer || !user || !employeeHappiness ) {
      return <LoadingScreen fullScreen='fullScreen' />
    } else if(customerId === null){
      return <div>
        Invalid customer
      </div>
    } else {
      if(!loggedInUser) {
        return (
          <div className='app guest' >
            <Video />
            <Login />
            <div id="top" className='top loggedOut' style={{
              backgroundImage: `url(${TopBackground})`,
              backgroundSize: 'cover',
            }} >
              <Header />
              <AirMeter />
            </div>
            <div id="content" className="container">
              <div id="center" className='guest'>
                <CompanyWidget />
                <WeatherWidget />
                <PuffWidget/>
              </div>
            </div>
          </div>
        );
      } else {
        // check if new highFives
        let newHighFives = ''
        if(highFives) {
          newHighFives = highFives.filter(highFive => highFive.read !== true ).length
        }
        return (
          <div className='app' >
            <Video />
            <Profile />
            <HighFives />
            {user.admin ? <Employees /> : null }
            {user.admin ? <HappinessFollowUp /> : null }
            <EditShortcuts />
            <Settings />
            <div id="top" className="top" style={{
              backgroundImage: `url(${TopBackground})`,
              backgroundSize: 'cover',
            }} >
              <Header newHighFives={newHighFives} />
              <AirMeter />
            </div>
            <div id="content" className="container">
              <div id="center" >
                <Shortcuts />
                <HappinessWidget user={user} />
                <WeatherWidget />
                <PuffWidget/>
              </div>
              <div id="sidebar">
                <HighFive />
                <Leaderboard />
              </div>
            </div>
          </div>
        );
      }

    }
  }
}

function mapStateToProps(state) {
  return {
    loggedInUser: loggedInUser(state),
    user: state.general.user,
    highFives: state.general.highFives,
    employeeHappiness: state.general.company.employeeHappiness,
    customerId: state.general.company.customerId,
    validatingCustomer: state.general.validatingCustomer,
  };
}

export default connect(mapStateToProps, {startup, sync})(Main);
